import { render } from "./AppCustomPagination.vue?vue&type=template&id=ba54b2b6&scoped=true"
import script from "./AppCustomPagination.vue?vue&type=script&lang=js"
export * from "./AppCustomPagination.vue?vue&type=script&lang=js"

import "./AppCustomPagination.vue?vue&type=style&index=0&id=ba54b2b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba54b2b6"]])

export default __exports__